import React, { useContext, useEffect, useState } from "react";
import { Container } from "reactstrap";
import MenuRegular from "../components/menu/MenuRegular";
import PromoCarousel from "../components/menu/PromoCarousel";
import MenuPromo from "../components/menu/MenuPromo";
import MenuVertical from "../components/menu/MenuVertical";
import { useLocation } from "react-router-dom";
import { PublicContext } from "../components/PublicContext"
import LocationOrderType from "../components/LocationOrderType";
import dayjs from 'dayjs';

export default function Menu() {
    const { stores, setMenuUrl, selectedStore } = useContext(PublicContext);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    // Parse the query parameters from the location search string
    const queryParams = new URLSearchParams(location.search);
    // Get the values of storeCode and storeId from the query parameters
    const storeCode = queryParams.get("storeCode") ?? null;
    const storeId = queryParams.get("storeId") ?? null;
    const deliveryOrPickUp = queryParams.get("deliveryOrPickUp") ?? null;
    const address = queryParams.get("address") ?? null;
    const referral = queryParams.get("referral") ?? null;
    const [urlDecoded, setUrlDecoded] = useState(false);

    if (sessionStorage.getItem("scheduleDate") == null || sessionStorage.getItem("scheduleTime") == null) {
        sessionStorage.setItem("scheduleDate", dayjs().format('MMM-DD'));
        sessionStorage.setItem("scheduleTime", "now");
    }

    useEffect(() => {
        //console.log("Menu useEffect");
        let storeName = null;
        if (storeCode) {
            //console.log(stores);
            //console.log(storeCode);
            let store = stores.find(s => s.storeCode === storeCode);
            let findStoreId = store.storeId;
            //console.log("findStoreId: " + findStoreId);
            sessionStorage.setItem("selectedStore", JSON.stringify({ storeCode: storeCode, storeId: findStoreId }));
            setUrlDecoded(true);
            sessionStorage.setItem("menuUrl", queryParams);
            setMenuUrl(queryParams);
            storeName = store.storeName;
        }
        if (storeId) {
            //console.log(storeId);
            let store = stores.find(s => s.storeId == storeId);
            let findStoreCode = store.storeCode;
            //console.log("findStoreCode: " + findStoreCode);
            sessionStorage.setItem("selectedStore", JSON.stringify({ storeCode: findStoreCode, storeId: storeId }));
            setUrlDecoded(true);
            sessionStorage.setItem("menuUrl", queryParams);
            setMenuUrl(queryParams);
            setLoading(false);
            selectedStore.current = { storeCode: findStoreCode, storeId: storeId };
            storeName = storeName ?? store.storeName;
        }

        if (referral) {
            sessionStorage.setItem("referral", referral);
            const trackedKey = `referralTracked_${referral}`;
            if (!localStorage.getItem(trackedKey)) {
                if (window.gtag) {
                    window.gtag('event', 'Referral', {
                        event_category: 'Referral',
                        event_label: referral,
                        referral_code: referral,
                        store_location: storeName ?? storeCode ?? storeId ?? 'unknown',
                        timestamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    });
                }

                let customerEmail = null;
                let customerId = null;
                try {
                    const customer = JSON.parse(sessionStorage.getItem("customer") || "null");
                    if (customer) {
                        customerEmail = customer.email ?? customer.Email ?? null;
                        customerId = customer.customerId ?? customer.CustomerId ?? null;
                    }
                } catch (e) {
                    // ignore parse errors
                }

                const resolvedStoreCode = storeCode
                    ?? (storeId && stores.find(s => s.storeId == storeId)?.storeCode)
                    ?? null;
                const resolvedStoreId = storeId
                    ? Number(storeId)
                    : (storeCode && stores.find(s => s.storeCode === storeCode)?.storeId) ?? null;

                fetch("api/ReferralVisits", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        referralCode: referral,
                        storeCode: resolvedStoreCode,
                        storeId: resolvedStoreId,
                        customerEmail,
                        customerId,
                    }),
                })
                    .then((response) => {
                        if (response.ok) {
                            localStorage.setItem(trackedKey, "1");
                        }
                    })
                    .catch(() => {
                        // Leave trackedKey unset so a later visit can retry
                    });
            }
        }
    }, []);

    return (
        <div>
            <Container tag="main">
                {loading && !urlDecoded ?
                    <></>
                    :
                    <MenuVertical />
                }
                {/*<LocationOrderType />*/}
            </Container>
        </div>
    );
}